import type { Brands } from '@edreamsodigeo/frontend-core';

export interface LogoType {
  primeLong: string;
  short: string;
}

export interface LogoTheme {
  default: LogoType;
  negative: LogoType;
}

interface BrandLogoProps {
  brand: Brands;
  type: keyof LogoType;
  theme: keyof LogoTheme;
}

const BRAND_LOGO_MAP: Record<Brands, LogoTheme> = {
  ED: {
    default: {
      primeLong:
        '/images/onefront/bluestone/ED/prime_logo/ED-logo-prime-long.svg',
      short: '/images/onefront/bluestone/ED/Logo_eDreams_RGB.svg',
    },
    negative: {
      primeLong:
        '/images/onefront/bluestone/ED/prime_logo/ED-logo-prime-negative-long.svg',
      short: '/images/onefront/bluestone/ED/eDreams_logo_negative.svg',
    },
  },
  OP: {
    default: {
      primeLong:
        '/images/onefront/bluestone/OP/prime_logo/OP-logo-prime-long.svg',
      short: '/images/onefront/bluestone/OP/Logo_Opodo_RGB.svg',
    },
    negative: {
      primeLong:
        '/images/onefront/bluestone/OP/prime_logo/OP-logo-prime-negative-long.svg',
      short: '/images/onefront/bluestone/OP/Opodo_logo_negative.svg',
    },
  },
  GO: {
    default: {
      primeLong:
        '/images/onefront/bluestone/GV/prime_logo/GO-logo-prime-long.svg',
      short: '/images/onefront/bluestone/GV/Logo_GOVoyages_RGB.svg',
    },
    negative: {
      primeLong:
        '/images/onefront/bluestone/GV/prime_logo/GO-logo-prime-negative-long.svg',
      short: '/images/onefront/bluestone/GV/GOVoyages_logo_negative.svg',
    },
  },
  TR: {
    default: {
      primeLong:
        '/images/onefront/bluestone/ED/prime_logo/ED-logo-prime-long.svg',
      short: '/images/onefront/bluestone/ED/Logo_eDreams_RGB.svg',
    },
    negative: {
      primeLong:
        '/images/onefront/bluestone/ED/prime_logo/ED-logo-prime-negative-long.svg',
      short: '/images/onefront/bluestone/ED/eDreams_logo_negative.svg',
    },
  },
};

const fallbackLogo = BRAND_LOGO_MAP.ED.default.short;

const useBrandLogoUrl = (args: BrandLogoProps): string => {
  const { brand, theme, type } = args;
  const result = BRAND_LOGO_MAP[brand]?.[theme]?.[type];
  return result || fallbackLogo;
};

export default useBrandLogoUrl;
